import { Box, Checkbox, Tooltip } from '@mui/material';
import { SearchContext } from 'context/SearchContext';
import { useContext, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { SearchDocument } from 'types/Search';
import StarIcon from '@mui/icons-material/Star';
import StarIconOutline from '@mui/icons-material/StarOutline';
import { useUserState } from 'context/User';
import { UserStateContextType } from 'components/constants/Constants';

interface BookmarkProps {
  product: SearchDocument;
  isBookmarked: boolean;
}

export const Bookmark = (props: BookmarkProps) => {
  const { isAuthenticated } = useAuth();
  const userState = useUserState();
  const [bookmarkState, setBookmarkState] = useState(props.isBookmarked);

  useEffect(() => {
    setBookmarkState(props.isBookmarked);
  }, [props.isBookmarked]);

  const searchContext = useContext(SearchContext);

  return (
    <Box>
      <Tooltip
        title={
          isAuthenticated
            ? !bookmarkState
              ? 'Add to your bookmarks'
              : 'Remove bookmark'
            : 'Log in to be able to bookmark a product'
        }
      >
        <Checkbox
          checked={bookmarkState}
          disabled={userState.type === UserStateContextType.NOT_AUTHENTICATED}
          onChange={() => {
            searchContext.onBookmarkChange?.(props.product, bookmarkState);
            setBookmarkState(!bookmarkState);
          }}
          onClick={e => e.stopPropagation()}
          icon={<StarIconOutline />}
          checkedIcon={<StarIcon sx={{ color: 'primary' }} />}
        />
      </Tooltip>
    </Box>
  );
};
